import { Middleware } from 'redux'

interface SentryLike {
  addBreadcrumb: (breadcrumb: {
    message?: string
    category?: string
    level?: string
    data?: { payload?: unknown }
  }) => void
}

const reduxSentryMiddleware =
  (Sentry: SentryLike): Middleware =>
  () =>
  (next) =>
  (action: { type: string; payload?: unknown }) => {
    Sentry.addBreadcrumb({
      message: action.type,
      category: 'redux-action',
      level: 'info',
      data: {
        payload: action.payload,
      },
    })
    return next(action)
  }

export default reduxSentryMiddleware
